const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  // TRACKING
  GET_LIST_TRACKING_BEGINS: 'GET_LIST_TRACKING_BEGINS',
  GET_LIST_TRACKING_SUCCESS: 'GET_LIST_TRACKING_SUCCESS',
  GET_LIST_TRACKING_FAILURE: 'GET_LIST_TRACKING_FAILURE',
  GET_DETAIL_TRACKING_BEGINS: 'GET_DETAIL_TRACKING_BEGINS',
  GET_DETAIL_TRACKING_SUCCESS: 'GET_DETAIL_TRACKING_SUCCESS',
  GET_DETAIL_TRACKING_FAILURE: 'GET_DETAIL_TRACKING_FAILURE',
  GET_SLOTS_TRACKING_BEGINS: 'GET_SLOTS_TRACKING_BEGINS',
  GET_SLOTS_TRACKING_SUCCESS: 'GET_SLOTS_TRACKING_SUCCESS',
  GET_SLOTS_TRACKING_FAILURE: 'GET_SLOTS_TRACKING_FAILURE',
  POST_MODIFY_APPOINTMENT_TRACKING_BEGINS: 'POST_MODIFY_APPOINTMENT_TRACKING_BEGINS',
  POST_MODIFY_APPOINTMENT_TRACKING_SUCCESS: 'POST_MODIFY_APPOINTMENT_TRACKING_SUCCESS',
  POST_MODIFY_APPOINTMENT_TRACKING_FAILURE: 'POST_MODIFY_APPOINTMENT_TRACKING_FAILURE',
  RESET_POST_MODIFY_APPOINTMENT_TRACKING: 'RESET_POST_MODIFY_APPOINTMENT_TRACKING',
  POST_CREATE_APPOINTMENT_TRACKING_BEGINS: 'POST_CREATE_APPOINTMENT_TRACKING_BEGINS',
  POST_CREATE_APPOINTMENT_TRACKING_SUCCESS: 'POST_CREATE_APPOINTMENT_TRACKING_SUCCESS',
  POST_CREATE_APPOINTMENT_TRACKING_FAILURE: 'POST_CREATE_APPOINTMENT_TRACKING_FAILURE',
  RESET_POST_CREATE_APPOINTMENT_TRACKING: 'RESET_POST_CREATE_APPOINTMENT_TRACKING',
  POST_MODIFY_PHONE_TRACKING_BEGINS: 'POST_MODIFY_PHONE_TRACKING_BEGINS',
  POST_MODIFY_PHONE_TRACKING_SUCCESS: 'POST_MODIFY_PHONE_TRACKING_SUCCESS',
  POST_MODIFY_PHONE_TRACKING_FAILURE: 'POST_MODIFY_PHONE_TRACKING_FAILURE',
  // POinfo
  GET_MY_POS_INFO: 'TRACKING/GET_MY_POS_INFO',
  GET_MY_POS_INFO_ERROR: 'GET_MY_POS_INFO_ERROR',
  GET_MY_POS_INFO_SUCCESS: 'TRACKING/GET_MY_POS_INFO_SUCCESS',
  GET_MY_POS_INFO_FAILURE: 'TRACKING/GET_MY_POS_INFO_FAILURE',
  // Celeris
  GET_CELERIS_INFO: 'TRACKING/GET_CELERIS_INFO',
  GET_CELERIS_INFO_SUCCESS: 'TRACKING/GET_CELERIS_INFO_SUCCESS',
  GET_CELERIS_INFO_FAILURE: 'TRACKING/GET_CELERIS_INFO_FAILURE',
  //orderDetails
  ORDER_DETAILS_TRACKING_BEGINS: 'ORDER_DETAILS_TRACKING_BEGINS',
  ORDER_DETAILS_TRACKING_SUCCESS: 'ORDER_DETAILS_TRACKING_SUCCESS',
  ORDER_DETAILS_TRACKING_FAILURE: 'ORDER_DETAILS_TRACKING_FAILURE',
};

export const actions = {
  // Actions for tracking
  getListTracking: (data) => ({
    type: types.GET_LIST_TRACKING_BEGINS,
    ...data
  }),
  successGetListTracking: (data, listTrackingcached) => ({
    type: types.GET_LIST_TRACKING_SUCCESS,
    payload: { ...data, listTrackingcached },
  }),
  failureGetListTracking: (error) => ({
    type: types.GET_LIST_TRACKING_FAILURE,
    payload: error,
  }),
  getDetailTracking: (data) => ({
    type: types.GET_DETAIL_TRACKING_BEGINS,
    ...data,
  }),
  successGetDetailTracking: (data) => ({
    type: types.GET_DETAIL_TRACKING_SUCCESS,
    payload: data,
  }),
  failureGetDetailTracking: (error) => ({
    type: types.GET_DETAIL_TRACKING_FAILURE,
    payload: error,
  }),
  getSlotsTracking: (data) => ({
    type: types.GET_SLOTS_TRACKING_BEGINS,
    ...data,
  }),
  successGetSlotsTracking: (data) => ({
    type: types.GET_SLOTS_TRACKING_SUCCESS,
    payload: data,
  }),
  failureGetSlotsTracking: (error) => ({
    type: types.GET_SLOTS_TRACKING_FAILURE,
    payload: error,
  }),
  postModifyAppointment: (params) => ({
    type: types.POST_MODIFY_APPOINTMENT_TRACKING_BEGINS,
    payload: params,
  }),
  successPostModifyAppointment: (data) => ({
    type: types.POST_MODIFY_APPOINTMENT_TRACKING_SUCCESS,
    payload: data,
  }),
  failurePostModifyAppointment: (error) => ({
    type: types.POST_MODIFY_APPOINTMENT_TRACKING_FAILURE,
    payload: error,
  }),
  resetPostModifyAppointment: () => ({
    type: types.RESET_POST_MODIFY_APPOINTMENT_TRACKING,
  }),
  postCreateAppointment: (params) => ({
    type: types.POST_CREATE_APPOINTMENT_TRACKING_BEGINS,
    payload: params,
  }),
  successPostCreateAppointment: (data) => ({
    type: types.POST_CREATE_APPOINTMENT_TRACKING_SUCCESS,
    payload: data,
  }),
  failurePostCreateAppointment: (error) => ({
    type: types.POST_CREATE_APPOINTMENT_TRACKING_FAILURE,
    payload: error,
  }),
  resetPostCreateAppointment: () => ({
    type: types.RESET_POST_CREATE_APPOINTMENT_TRACKING,
  }),
  postModifyPhone: (params) => ({
    type: types.POST_MODIFY_PHONE_TRACKING_BEGINS,
    payload: params,
  }),
  successPostModifyPhone: (data) => ({
    type: types.POST_MODIFY_PHONE_TRACKING_SUCCESS,
    payload: data,
  }),
  failurePostModifyPhone: (error) => ({
    type: types.POST_MODIFY_PHONE_TRACKING_FAILURE,
    payload: error,
  }),
  // PRODUCTINFO
  getTelcoInfoFromArrayPO: (arrayProductOffering) => ({
    type: types.GET_MY_POS_INFO,
    arrayProductOffering,
  }),
  failuredGetTelcoInfoArrayFromPO: () => ({
    type: types.GET_MY_POS_INFO_ERROR,
  }),
  successGetTelcoInfoArrayFromPO: (data) => ({
    type: types.GET_MY_POS_INFO_SUCCESS,
    payload: data,
  }),
  getCelerisInfo: (co, sho) => ({ type: types.GET_CELERIS_INFO, co, sho }), // co: customer order
  getCelerisInfoSuccess: (data) => ({
    type: types.GET_CELERIS_INFO_SUCCESS,
    payload: data,
  }),
  getCelerisInfoFailure: () => ({ type: types.GET_CELERIS_INFO_FAILURE }),
  // OrderDetails
  getOrderDetails: (params) => ({
    type: types.ORDER_DETAILS_TRACKING_BEGINS,
    payload: params,

  }),
  successOrderDetails: (data) => ({
    type: types.ORDER_DETAILS_TRACKING_SUCCESS,
    payload: data
  }),
  failureOrderDetails: (error) => ({
    type: types.ORDER_DETAILS_TRACKING_FAILURE,
    payload: error,
  }),
};

export const initialState = {
  // TRACKING
  listTracking: [],
  moreElements: false,
  pageNumber: 1,
  listTrackingError: null,
  listTrackingFetching: false,
  listTrackingcached:false,
  detailTracking: null,
  detailTrackingError: null,
  detailTrackingFetching: false,
  slotsTracking: null,
  slotsTrackingError: null,
  slotsTrackingFetching: false,
  modifyAppointment: null,
  modifyAppointmentFetching: false,
  modifyAppointmentError: null,
  createAppointment: null,
  createAppointmentFetching: false,
  createAppointmentError: null,
  modifyPhone: null,
  modifyPhoneFetching: false,
  modifyPhoneError: null,
  // MASSIVE POInfo
  POInfoFetching: false,
  POInfoInfoFetched: false,
  POInfoInfoError: false,
  // Celeris
  celerisInfo: null,
  celerisInfoFetching: false,
  celerisInfoError: false,
  celerisInfoFetched: false,
  // orderDetails
  orderDetails: null,
  orderDetailsFetching: false,
  orderDetailsError: null,
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { tracking } = payload;
      return {
        ...state,
        ...tracking,
      };
    }
    case types.GET_LIST_TRACKING_BEGINS:
      return {
        ...state,
        listTrackingError: null,
        listTrackingFetching: true,
      };
    case types.GET_LIST_TRACKING_SUCCESS: {
      const { orders, moreElements, pageNumber, listTrackingcached } = payload;
      
      let pageNumberToState = state.pageNumber;
      let listTrackingToShow = [...orders];
      if (pageNumber > pageNumberToState) {
        listTrackingToShow = [...state.listTracking, ...orders];
        pageNumberToState = pageNumber;
      }
      return {
        ...state,
        listTrackingError: false,
        listTrackingFetching: false,
        listTrackingcached,
        listTracking: [...listTrackingToShow],
        moreElements,
        pageNumber: pageNumberToState,
      };
    }
    case types.GET_LIST_TRACKING_FAILURE:
      return {
        ...state,
        listTracking: null,
        listTrackingError: true,
        listTrackingFetching: false,
      };
    case types.GET_DETAIL_TRACKING_FAILURE:
      return {
        ...state,
        detailTracking: null,
        detailTrackingError: true,
        detailTrackingFetching: false,
      };
    case types.GET_DETAIL_TRACKING_BEGINS:
      return {
        ...state,
        detailTrackingError: null,
        detailTrackingFetching: true,
      };
    case types.GET_DETAIL_TRACKING_SUCCESS: {
      const newTrackingDetails = payload;

      const { code } = newTrackingDetails;
      const newTrackingDetailsStructure = {
        ...state.detailTracking,
      };
      newTrackingDetailsStructure[code] = newTrackingDetails;
      return {
        ...state,
        detailTrackingError: false,
        detailTrackingFetching: false,
        detailTracking: newTrackingDetailsStructure,
      };
    }
    case types.GET_SLOTS_TRACKING_FAILURE:
      return {
        ...state,
        slotsTracking: null,
        slotsTrackingError: true,
        slotsTrackingFetching: false,
      };
    case types.GET_SLOTS_TRACKING_BEGINS:
      return {
        ...state,
        slotsTrackingError: null,
        slotsTrackingFetching: true,
      };
    case types.GET_SLOTS_TRACKING_SUCCESS: {
      const newTrackingSlots = payload;
      return {
        ...state,
        slotsTrackingError: false,
        slotsTrackingFetching: false,
        slotsTracking: newTrackingSlots,
      };
    }
    case types.POST_MODIFY_APPOINTMENT_TRACKING_BEGINS:
      return {
        ...state,
        modifyAppointment: null,
        modifyAppointmentFetching: true,
        modifyAppointmentError: false,
      };
    case types.POST_MODIFY_APPOINTMENT_TRACKING_SUCCESS:
      return {
        ...state,
        modifyAppointment: payload,
        modifyAppointmentFetching: false,
        modifyAppointmentError: false,
      };
    case types.POST_MODIFY_APPOINTMENT_TRACKING_FAILURE:
      return {
        ...state,
        modifyAppointment: null,
        modifyAppointmentFetching: false,
        modifyAppointmentError: true,
      };
    case types.RESET_POST_MODIFY_APPOINTMENT_TRACKING:
      return {
        ...state,
        modifyAppointment: null,
        modifyAppointmentFetching: false,
        modifyAppointmentError: false,
      };
    case types.POST_CREATE_APPOINTMENT_TRACKING_BEGINS:
      return {
        ...state,
        createAppointment: null,
        createAppointmentFetching: true,
        createAppointmentError: false,
      };
    case types.POST_CREATE_APPOINTMENT_TRACKING_SUCCESS:
      return {
        ...state,
        createAppointment: payload,
        createAppointmentFetching: false,
        createAppointmentError: false,
      };
    case types.POST_CREATE_APPOINTMENT_TRACKING_FAILURE:
      return {
        ...state,
        createAppointment: null,
        createAppointmentFetching: false,
        createAppointmentError: true,
      };
    case types.RESET_POST_CREATE_APPOINTMENT_TRACKING:
      return {
        ...state,
        createAppointment: null,
        createAppointmentFetching: false,
        createAppointmentError: false,
      };
    case types.POST_MODIFY_PHONE_TRACKING_BEGINS:
      return {
        ...state,
        modifyPhone: null,
        modifyPhoneFetching: true,
        modifyPhoneError: false,
      };
    case types.POST_MODIFY_PHONE_TRACKING_SUCCESS:
      return {
        ...state,
        modifyPhone: payload,
        modifyPhoneFetching: false,
        modifyPhoneError: false,
      };
    case types.POST_MODIFY_PHONE_TRACKING_FAILURE:
      return {
        ...state,
        modifyPhone: null,
        modifyPhoneFetching: false,
        modifyPhoneError: true,
      };
    // ALL PRODUCT INFO
    case types.GET_MY_POS_INFO:
      return {
        ...state,
        POInfoFetching: true,
        POInfoError: false,
      };
    case types.GET_MY_POS_INFO_ERROR:
      return {
        ...state,
        POInfoFetching: false,
        POInfoError: true,
      };
    case types.GET_MY_POS_INFO_SUCCESS: {
      return {
        ...state,
        POInfo: payload,
        POInfoFetching: false,
        POInfoError: false,
      };
    }
    case types.GET_CELERIS_INFO: {
      return {
        ...state,
        celerisInfoFetching: true,
        celerisInfoFetched: false,
      };
    }
    case types.GET_CELERIS_INFO_SUCCESS: {
      const celerisInfo = payload;
      const lastDataCelerisInfo = {
        ...state.celerisInfo,
      };
      const lastKeys = Object.keys(lastDataCelerisInfo);
      if (celerisInfo && celerisInfo.sho) {
        const exist = lastKeys.find((elem) => elem === celerisInfo.sho);
        if (!exist) {
          lastDataCelerisInfo[celerisInfo.sho] = payload;
        }
      } else if (celerisInfo && celerisInfo.co) {
        const exist = lastKeys.find((elem) => elem === celerisInfo.co);
        if (!exist) {
          lastDataCelerisInfo[celerisInfo.co] = payload;
        }
      }

      return {
        ...state,
        celerisInfo: lastDataCelerisInfo,
        celerisInfoFetching: false,
        celerisInfoError: false,
        celerisInfoFetched: true,
      };
    }
    case types.GET_CELERIS_INFO_FAILURE: {
      return {
        ...state,
        celerisInfoFetching: false,
        celerisInfoError: true,
        celerisInfoFetched: true,
      };
    }
    // orderDetails
    case types.ORDER_DETAILS_TRACKING_BEGINS:
      return {
        ...state,
        orderDetails: null,
        orderDetailsFetching: true,
      };
    case types.ORDER_DETAILS_TRACKING_SUCCESS: {
      
      const newOrderDetailsTracking = payload;

      return {
        ...state,
        orderDetailsError: false,
        orderDetailsFetching: false,
        orderDetails: newOrderDetailsTracking,
      };
    }
    case types.ORDER_DETAILS_TRACKING_FAILURE:
      return {
        ...state,
        orderDetails: null,
        orderDetailsError: true,
        orderDetailsFetching: false,
      };
    default:
      return state;
  }
}

export default reducer;
